var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1_Signin_01",
    transform: "translate(-795.000000, -414.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(693.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(48.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(52.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,17 L4,17 C2.9,17 2.01,17.9 2.01,19 L2,31 C2,32.1 2.9,33 4,33 L20,33 C21.1,33 22,32.1 22,31 L22,19 C22,17.9 21.1,17 20,17 L20,17 Z M20,21 L12,26 L4,21 L4,19 L12,24 L20,19 L20,21 L20,21 Z",
    id: "Email"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.5e75a18bd6ac44ec756eb8cac2700a0b.svg";
export { ForwardRef as ReactComponent };